import { render } from "./StoreTransactionsTable.vue?vue&type=template&id=01297c02&scoped=true"
import script from "./StoreTransactionsTable.vue?vue&type=script&lang=js"
export * from "./StoreTransactionsTable.vue?vue&type=script&lang=js"

import "./StoreTransactionsTable.vue?vue&type=style&index=0&id=01297c02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01297c02"]])

export default __exports__